export default __webpack_public_path__ + "static/media/guide_044.76809faf.md";